import React, { useEffect, useState, useMemo } from 'react';
import CustomDataTable from '../components/CustomDataTable';
import { FormControl, Modal } from 'react-bootstrap';
import { PencilSquare, ShareFill, Trash } from 'react-bootstrap-icons';
import { useDispatch, useSelector } from 'react-redux';
import { createAssessments, deleteAssessment, fetchAssessments } from '../store/assessmentsSlice';
import CustomModal from '../components/CustomModal';
import CustomInput from '../components/CustomInput';
import { useFormik } from 'formik';
import * as yup from "yup";
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import swal from 'sweetalert';
import CustomButton from '../components/CustomButton';
import ShareAssessmentForm from '../components/ShareAssessmentForm';
import CreateAssessmentWithAIForm from '../components/CreateAssessmentWithAIForm';
import TabTitle from '../components/TabTitle';
import CustomBreadcrumb from '../components/CustomBreadcrumb';
import DynamicTable from '../components/CustomTable';
import { Button, Input, Tooltip } from 'antd';
import { DeleteOutlined, EditOutlined, ShareAltOutlined } from '@ant-design/icons';
import { getUserDetail } from '../store/userSlice';

const Assessments = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [assessmentsDisplayed, setAssessmentsDisplayed] = useState([]);
  const [selectedRow, setSelectedRow] = useState({});
  const [searchQuery, setSearchQuery] = useState("");
  const [isCreateOpen, setIsCreateOpen] = useState(false);
  const [isShareOpen, setIsShareOpen] = useState(false);
  const [isCreateAssessmentAIOpen, setIsCreateAssessmentAIOpen] = useState(false);
  const { assessments, loading, error } = useSelector((state) => state.assessments);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(5);
  const [page, setPage] = useState(1);
  const user = useSelector((state) => state.users.singleRecord?.data);

  const handleDelete = async (id) => {
    swal({
      title: 'Are you sure?',
      text: 'This action cannot be undone.',
      icon: 'warning',
      buttons: {
        cancel: 'Cancel',
        confirm: 'Delete',
      },
      dangerMode: true,
    }).then(async (confirmed) => {
      // User clicked the 'Delete' button
      // if (confirmed) {
      //   try {
      //     console.log("clicked==2");

      //     const res = await dispatch(deleteAssessment({assessment_id : id})).unwrap();          
      //     // setAssessmentsDisplayed([]);
      //     console.log(res, "res");

      //     setIsRefetch(true);
      //     toast.success('Assessment deleted successfully');
      //   } catch (err) {
      //     toast.error(err?.data?.message);
      //   };
      // } else {
      //   // User clicked the 'Cancel' button
      //   // Handle the cancellation
      // }

      if (confirmed) {
        try {
          // Call the API when confirmed
          const response = await dispatch(deleteAssessment({ assessment_id: id })).unwrap();

          if (response?.id) {
            swal("Deleted!", "The item has been successfully deleted.", "success");
            // setAssessmentsDisplayed(assessments?.data?.filter((item) => item.id !== id));
          } else {
            console.error("Error deleting item");
            swal("Error!", "Failed to delete the item.", "error");
          }
        } catch (error) {
          console.error("API error:", error);
          swal("Error!", "An unexpected error occurred.", "error");
        }
      } else {
        console.log("User cancelled the action");
      }
    });
  }

  const companyId = user?.company;

  const queryParams = useMemo(() => ({
    search: searchQuery,
    page,
    page_size: perPage,
    ...(companyId && { company_id: companyId }),
  }), [searchQuery, page, perPage, companyId]);

  useEffect(() => {
    dispatch(fetchAssessments(queryParams));
  }, [dispatch, queryParams]);

  useEffect(() => {
    if (assessments && assessments?.page_details?.count) setTotalRows(assessments?.page_details?.count);

    if (assessments && assessments?.data?.length > 0) {
      setAssessmentsDisplayed(assessments?.data)
    } else setAssessmentsDisplayed([])
  }, [assessments, loading, error]);

  useEffect(() => {
    dispatch(getUserDetail());
  }, [dispatch]);

  const data = assessmentsDisplayed && assessmentsDisplayed.length > 0
    ? assessmentsDisplayed.map((assessment) => assessment)
    : [];

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const createAssessmentValidationSchema = yup.object({
    name: yup
      .string("Please enter name")
      .required("Please enter name"),
    description: yup
      .string("Please enter description")
      .required("Please enter description"),
    passing_perc: yup
      .string("Please enter passing percentage")
      .required("Please enter passing percentage"),
    question_number: yup
      .string("Please enter no. of question")
      .required("Please enter no. of question"),
  });

  const createAssessmentFormik = useFormik({
    initialValues: {
      name: "",
      description: "",
      passing_perc: "",
      question_number: "",
    },
    validationSchema: createAssessmentValidationSchema,
    onSubmit: async (values) => {
      try {
        const response = await dispatch(createAssessments(values)).unwrap();
        setIsCreateOpen(false);
        toast.success('Assessment created successfully');
        navigate(`/admin/assessment/${response?.data?.id}`);
      } catch (error) {
        console.log(error, "error");
      }
    }
  });

  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    isSubmitting,
  } = createAssessmentFormik;

  const handleCreateClose = () => {
    setIsCreateOpen(false);
    createAssessmentFormik.resetForm();
  };

  const breadcrumbList = [
    { title: "Assessments", href: "" },
  ];

  // Pagination configuration
  const pagination = {
    current: page,  // Current page
    pageSize: 15,  // Number of items per page
    total: totalRows, // Total number of records (adjust as per your data)
    onChange: (page) => {
      console.log('Page:', page);
      setPage(page);
    },
  };
  const columns = [
    {
      title: 'Id',
      dataIndex: 'id',
      key: 'id',
      sorter: (a, b) => a.id - b.id, // Numerical comparison for sorting
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      sorter: (a, b) => a.name.localeCompare(b.name), // String comparison for sorting
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
      width: "30%",
      render: (text) => {
        // Check if description length is greater than 150 characters
        return text.length > 60 ? text.substring(0, 60) + '...' : text;
      }
    },
    {
      title: 'Passing Percentage',
      dataIndex: 'passing_perc',
      key: 'passing_perc',
      render: (text) => text, // Format the passing percentage if necessary
      sorter: (a, b) => a.id - b.id, // Numerical comparison for sorting
    },
    {
      title: 'Action',
      key: 'action',
      align: 'center',
      render: (text, row) => (
        <div className="button-table-wrap d-flex justify-content-center align-items-center gap-2">
          <Button type='primary' size="large" onClick={() =>
            navigate(`/admin/assessment/${row.id}`)
          } shape="circle" icon={<EditOutlined />} />
          <Button type='primary' className='info_btn' size="large" onClick={() => {
            setIsShareOpen(true);
            setSelectedRow(row);
          }} shape="circle" icon={<ShareAltOutlined />} />
          <Button type='primary' danger size="large" onClick={() => handleDelete(row.id)} shape="circle" icon={<DeleteOutlined />} />
        </div>
      ),
    },
  ];
  return (
    <>
      <TabTitle title="Assessments" />
      <CustomBreadcrumb breadcrumbList={breadcrumbList} />
      <div className="main-content">
        <div className="container-fluid bg-white p-0">
          <div className="row mb-4">
            <div className="col-12 col-sm-12 col-md-5 col-lg-5">
              <div className="px-4">
                <Input className='custom_input_antd' size='large' value={searchQuery} placeholder="Search" allowClear onChange={handleSearchChange} />
              </div>
            </div>
            <div className="col-12 col-sm-12 col-md-7 col-lg-7">
              <div className="d-sm-flex d-block justify-content-md-end justify-content-center px-4 gap-3 flex-wrap text-center  mt-md-0 mt-3">
                <CustomButton className="mb-0 mt-3 mt-sm-0" onClick={() => setIsCreateAssessmentAIOpen(!isCreateAssessmentAIOpen)}>
                  Create Assessment With Ai
                </CustomButton>
                <CustomButton className="mb-0 mt-3 mt-sm-0 assessment-btn" onClick={() => setIsCreateOpen(!isCreateOpen)}>
                  Create Assessment
                </CustomButton>
              </div>
            </div>
          </div>
          <div className="row mb-4">
            <div className="col-lg-12">
              <div className="customize-table">
                <DynamicTable
                  columns={columns}
                  loading={loading} // Show loading spinner when true
                  data={data}
                  onRowClick={(record) => console.log('Row clicked:', record)}
                  pagination={pagination}  // Pass pagination prop
                />
              </div>
            </div>
          </div>
        </div>
        <CustomModal show={isCreateOpen}
          onHide={handleCreateClose} modalTitle="Create Assessment">
          <CustomInput name="name" label="Name" type="text" placeholder="Name" required error={touched?.passing_perc && Boolean(errors?.name)} errorText={touched?.name && errors?.name} onChange={handleChange} onBlur={handleBlur} value={values.name} />
          <CustomInput name="description" label="Description" type="text" placeholder="Description" required error={touched?.passing_perc && Boolean(errors?.description)} errorText={touched?.description && errors?.description} onChange={handleChange} onBlur={handleBlur} value={values.description} />
          <CustomInput name="passing_perc" label="Passing Precentage" type="number" placeholder="Passing Precentage" required error={touched?.passing_perc && Boolean(errors?.passing_perc)} errorText={touched?.passing_perc && errors?.passing_perc} onChange={handleChange} onBlur={handleBlur} value={values.passing_perc} />
          <CustomInput name="question_number" label="No of Question" type="number" placeholder="No of Question" required error={touched?.question_number && Boolean(errors?.question_number)} errorText={touched?.question_number && errors?.question_number} onChange={handleChange} onBlur={handleBlur} value={values.question_number} />
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCreateClose}>
              Close
            </Button>
            <CustomButton variant="primary" minWidth="90px" disabled={isSubmitting} onClick={handleSubmit} name="Save" isLoading={isSubmitting} />
          </Modal.Footer>
        </CustomModal>
        {isShareOpen && <ShareAssessmentForm assessment={selectedRow} isShareOpen={isShareOpen} setIsShareOpen={setIsShareOpen} />}
        {isCreateAssessmentAIOpen && <CreateAssessmentWithAIForm isCreateAssessmentAIOpen={isCreateAssessmentAIOpen} setIsCreateAssessmentAIOpen={setIsCreateAssessmentAIOpen} />}
      </div>
    </>
  )
}

export default Assessments;